const n = (e) => e.indexOf("s") !== e.length - 1 ? 0 : e.includes("ms") ? parseInt(e.replace("ms", ""), 10) : parseFloat(e.replace("s", "")) * 1e3;
export {
  n as timeStringToNumber
};
